
const Footer = () => {
  return (
    <footer className="bg-[#111111] py-12 border-t border-[#A2AEAB]/20">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center">
          <div className="mb-8">
            <div className="flex justify-center mb-2">
              <img 
                src="https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/1bcf13b5daffa6303a7ae256b0b51ed5.png" 
                alt="Skyview - A sua marca vista do céu" 
                className="h-26 w-auto"
              />
            </div>
          </div>

          <div className="flex justify-center space-x-8 mb-8">
            <a 
              href="https://instagram.com/skyviewfilmes" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#A2AEAB] hover:text-white transition-colors duration-300"
              aria-label="Instagram"
            >
              <i className="ri-instagram-line text-2xl"></i>
            </a>
            <a 
              href="https://youtube.com/@skyviewfilmes" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#A2AEAB] hover:text-white transition-colors duration-300"
              aria-label="YouTube"
            >
              <i className="ri-youtube-line text-2xl"></i>
            </a>
            <a 
              href="https://wa.me/5541997929641" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#A2AEAB] hover:text-white transition-colors duration-300"
              aria-label="WhatsApp"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
            </a>
          </div>

          <div className="text-center text-[#A2AEAB] text-sm">
            <p>© Skyview Filmes — A sua marca vista do céu. Curitiba - PR.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
